"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderFooterDestination = void 0;
var tslib_1 = require("tslib");
var map_creator_1 = require("../../../../../base-utils/map-creator");
var alt_chunk_destination_1 = require("../../document/alt-chunk-destination");
var body_destination_base_1 = require("../../document/body-destination-base");
var paragraph_destination_1 = require("../../paragraph/paragraph-destination");
var table_destination_1 = require("../../table/table/table-destination");
var HeaderFooterDestination = (function (_super) {
    tslib_1.__extends(HeaderFooterDestination, _super);
    function HeaderFooterDestination() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(HeaderFooterDestination.prototype, "elementHandlerTable", {
        get: function () {
            return HeaderFooterDestination.handlerTable;
        },
        enumerable: false,
        configurable: true
    });
    HeaderFooterDestination.handlerTable = new map_creator_1.MapCreator()
        .add('p', function (data) { return new paragraph_destination_1.ParagraphDestination(data); })
        .add('tbl', function (data) { return new table_destination_1.TableDestination(data); })
        .add('bookmarkStart', body_destination_base_1.BodyDestinationBase.onBookmarkStart)
        .add('bookmarkEnd', body_destination_base_1.BodyDestinationBase.onBookmarkEnd)
        .add('permStart', body_destination_base_1.BodyDestinationBase.onRangePermissionStart)
        .add('permEnd', body_destination_base_1.BodyDestinationBase.onRangePermissionEnd)
        .add('sdt', body_destination_base_1.BodyDestinationBase.onStructuredDocument)
        .add('customXml', body_destination_base_1.BodyDestinationBase.onCustomXml)
        .add('altChunk', function (data) { return new alt_chunk_destination_1.AltChunkDestination(data); })
        .get();
    return HeaderFooterDestination;
}(body_destination_base_1.BodyDestinationBase));
exports.HeaderFooterDestination = HeaderFooterDestination;
